import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { DataGrid } from "@material-ui/data-grid";
import { transmittalInboxListStyle } from "../../../styles/jss/components/transmittal/transmittalboxListStyle";
import Typography from "@material-ui/core/Typography";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import FullScreenDialog from "../../Dialog/FullScreenDialog";
import MailIcon from "@material-ui/icons/Mail";
import DraftsIcon from "@material-ui/icons/Drafts";
import Tooltip from "@material-ui/core/Tooltip";
import LaunchIcon from "@material-ui/icons/Launch";
import { Alert } from "../../Alert/Alert";

import TransmittalDetailsForm from "./TransmittalDetailsForm";

import {
  oceanBlueColor,
  grayColor,
  blackColor,
} from "../../../styles/jss/cmsMainStyle";

import { getTransmittalList } from "../../../dataSource/transmittal";

const useStyles = makeStyles((theme) => transmittalInboxListStyle(theme));
const InboxTypography = withStyles({
  root: {
    fontSize: 20,
    fontWeight: 600,
    color: blackColor,
  },
})(Typography);
const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
      backgroundColor: oceanBlueColor[4],
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    height: "100%",
    // cursor: "pointer"
  },
}))(MuiAccordionDetails);
const TransmittalInbox = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [p1Expanded, setp1Expanded] = useState(true);

  const handleP1MenuChange = () => {
    setp1Expanded((current) => !current);
  };
  const [list, setList] = useState([]);
  const [listMsg, setListMsg] = useState("");
  const [xmtlSeq, setXmtlSeq] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const store = require("store");
  const userCategoryCode = store.get("user_category_code") || "";
  const isInternal = userCategoryCode === "SANFIELD";
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "",
    title: "",
    content: "",
  });

  const getTransmittalListAction = async () => {
    getTransmittalList().then((res) => {
      let transmittallist = res.data.map((obj, index) => {
        return {
          id: ++index,
          ...obj,
        };
      });
      setList(transmittallist);
      if (res.data.length === 0) {
        setListMsg("No TRANSMITTAL");
      } else {
        setListMsg("");
      }
    });
  };
  useEffect(() => {
    const fetchTransmittalList = async () => {
      await getTransmittalListAction();
    };
    fetchTransmittalList();
  }, [openDialog, setOpenDialog]);
  const columns = [
    {
      field: "id",
      hide: "true",
    },
    {
      field: "is_read",
      renderCell: (params) =>
        params.value === "N" ? (
          <Tooltip title="Unread Transmittal">
            <MailIcon className={classes.readedIcon} />
          </Tooltip>
        ) : (
          <Tooltip title="Readed Transmittal">
            <DraftsIcon className={classes.unreadIcon} />
          </Tooltip>
        ),

      headerName: " ",
      width: 50,
    },
    {
      field: "xmtl_seq",
      renderCell: (params) => (
        <Tooltip title="View Transmittal">
          <LaunchIcon
            className={classes.viewIcon}
            onClick={() => {
              showXmtlDetails(params);
            }}
          />
        </Tooltip>
      ),
      headerName: " ",
      width: 50,
    },
    { field: "ref_no", headerName: "Transmittal Ref. No.", width: 300 },
    { field: "issue_by", headerName: "Issue By", width: 250 },
    { field: "createdate", headerName: "Issue Date", width: 200 },
    { field: "stage", headerName: "Stage", width: 200 },
    { field: "last_update_date", headerName: "Last Update Date", width: 200 },
  ];

  const showXmtlDetails = (params) => {
    setOpenDialog(true);
    setXmtlSeq(params.value);
  };
  // Build Alert
  const buildAlert = (data) => {
    setAlertData({
      type: data.type,
      title: data.title,
      content: data.content,
    });
    setAlertOpen(true);
  };
  return (
    <Fragment>
      <Alert
        open={alertOpen}
        alertType={alertData.type}
        alertTitle={alertData.title}
        alertContent={alertData.content}
        handleClose={() => setAlertOpen(false)}
      />
      <div style={{ width: "100%" }} className={classes.root}>
        <Accordion square expanded={p1Expanded} onChange={handleP1MenuChange}>
          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <InboxTypography>Transmittal Box</InboxTypography>
          </AccordionSummary>
          <div className={classes.transmittalList}>
            <AccordionDetails>
              <div style={{ width: "100%" }}>
                <DataGrid rows={list} columns={columns} pageSize={10} />
              </div>
            </AccordionDetails>
          </div>
        </Accordion>
      </div>
      {
        <div className={classes.detailsFullScreen}>
          <FullScreenDialog
            open={openDialog}
            dialogTitle={"Transmittal Details"}
            formContent={
              <TransmittalDetailsForm
                xmtlSeq={xmtlSeq}
                isInternal={isInternal}
                isNew={false}
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                buildAlert={buildAlert}
              />
            }
            button={[]}
            handleClose={() => {
              setOpenDialog(false);
            }}
          ></FullScreenDialog>
        </div>
      }
    </Fragment>
  );
};

export default TransmittalInbox;
